// extracted by mini-css-extract-plugin
export default {"wrapper":"imba-image__wrapper___NXaAI","img":"imba-image__img___x9if3"};